import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "ripple";
var classes = {
    SURFACE: 'mdc-ripple-surface'
};
var attributes = {
    TARGET: 'target',
    UNBOUNDED: 'unbounded'
};
export var RIPPLE_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    attributes: attributes
};
